import SignUpPage from './SignUp-Container';
export default SignUpPage;
